export default __webpack_public_path__ + "static/media/blastSlide2.b49a13e2.png";